import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { DisabilityModule } from '../../disability/disability.module';
import { PagesComponent } from './pages.component';
import { NgaModule } from '../../../theme/nga.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Angular2FontawesomeModule } from 'angular2-fontawesome/angular2-fontawesome';
import { DndModule } from 'ng2-dnd';

import {
  ButtonModule,
  SplitButtonModule,
  GrowlModule,
  MessagesModule,
  InputTextModule,
  PasswordModule,
  SlideMenuModule,
  FileUploadModule,
  DataTableModule,
  SharedModule,
  InputTextareaModule,
  DropdownModule,
  ChipsModule,
  DialogModule,
  RatingModule,
  ConfirmDialogModule,
  InputMaskModule,
  GMapModule,
  CheckboxModule,
  MultiSelectModule,
  AutoCompleteModule,
  SelectButtonModule,
  InputSwitchModule,
  ChartModule,
  ToggleButtonModule,
  AccordionModule,
  PanelModule,
  FieldsetModule,
  CalendarModule,
  TabViewModule,
  StepsModule,
  LightboxModule,
  TooltipModule,
  EditorModule,
  RadioButtonModule,
  ProgressBarModule,
} from "primeng/primeng";
import { SidebarModule } from "primeng/components/sidebar/sidebar";
import { ScheduleModule } from "primeng/components/schedule/schedule";

import { NgxChartsModule } from "@swimlane/ngx-charts";

import { StoreModule } from "@ngrx/store";

import { Angular2PromiseButtonModule } from "angular2-promise-buttons/dist";

import { AgmCoreModule } from "@agm/core";

import { HttpModule, Http, RequestOptions } from "@angular/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslatePoHttpLoader } from "@biesbjerg/ngx-translate-po-http-loader";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

// Dashboard
import { DashboardComponent } from "./dashboard/dashboard.component";
import { DashboardFinancialComponent } from "./dashboard-financial/dashboard-financial.component";
import { DashboardSorttimeCompaniesComponent } from "./dashboard-sorttime-companies/dashboard-sorttime-companies.component";

// Employee Virtual Office
import { EmployeeVirtualOfficeComponent } from "./employee-virtual-office/employee-virtual-office.component";

// Account settings
import { AccountComponent } from "./account/account.component";
import { AccountEditComponentComponent } from "./account/account-edit-component/account-edit-component.component";
import { EmployeeEditComponentComponent } from "./account/employee-edit-component/employee-edit-component.component";

// User
import { UsersComponent } from "./users/users.component";
import { NewUserComponent } from "./users/new-user/new-user.component";
import { UserComponent } from "./users/user/user.component";

// Companies
import { CompaniesComponent } from "./companies/companies.component";
import { NewCompanyComponent } from "./companies/new-company/new-company.component";
import { CompanyComponent } from "./companies/company/company.component";
import { SelectCompanyComponent } from "./companies/select-company/select-company.component";
import { MultiSelectCompaniesComponent } from "./companies/multiselect-companies/multiselect-companies.component";
import { AutocompleteCompanyComponent } from "./companies/autocomplete-company/autocomplete-company.component";

// Venues
import { VenuesComponent } from "./venues/venues.component";
import { NewVenueComponent } from "./venues/new-venue/new-venue.component";
import { VenueComponent } from "./venues/venue/venue.component";
import { SelectVenueComponent } from "./venues/select-venue/select-venue.component";

// Departments
import { DepartmentsComponent } from "./departments/departments.component";
import { NewDepartmentComponent } from "./departments/new-department/new-department.component";
import { DepartmentComponent } from "./departments/department/department.component";
import { SelectDepartmentComponent } from "./departments/select-department/select-department.component";

// EmployeePositions
import { EmployeePositionsComponent } from "./employee-positions/employee-positions.component";
import { NewEmployeePositionComponent } from "./employee-positions/new-employee-position/new-employee-position.component";
import { EmployeePositionComponent } from "./employee-positions/employee-position/employee-position.component";
import { SelectEmployeePositionComponent } from "./employee-positions/select-employee-position/select-employee-position.component";
import { AutocompleteEmployeeComponent } from "./employees/autocomplete-employee/autocomplete-employee.component";

// Employee
import { EmployeesComponent } from "./employees/employees.component";
import { NewEmployeeComponent } from "./employees/new-employee/new-employee.component";
import { EmployeeComponent } from "./employees/employee/employee.component";
import { SelectEmployeeComponent } from "./employees/select-employee/select-employee.component";

// Role
import { RolesComponent } from "./roles/roles.component";
import { NewRoleComponent } from "./roles/new-role/new-role.component";
import { RoleComponent } from "./roles/role/role.component";
import { SelectRoleComponent } from "./roles/select-role/select-role.component";

// Permission
import { PermissionsComponent } from "./permissions/permissions.component";
import { NewPermissionComponent } from "./permissions/new-permission/new-permission.component";
import { PermissionComponent } from "./permissions/permission/permission.component";
import { MultiSelectPermissionComponent } from "./permissions/multiselect-permissions/multiselect-permissions.component";

// CustomerGuide
import { CustomerGuidesComponent } from "./customer-guides/customer-guides.component";
import { NewCustomerGuideComponent } from "./customer-guides/new-customer-guide/new-customer-guide.component";
import { CustomerGuideComponent } from "./customer-guides/customer-guide/customer-guide.component";
import { AutocompleteCustomerGuideComponent } from "./customer-guides/autocomplete-customer-guide/autocomplete-customer-guide.component";
import { CustomerGuidesAttachDocumentationComponent } from "./customer-guides/customer-guides-attach-documentation/customer-guides-attach-documentation.component";

// CustomerGuide
import { CustomerGuidesSynergoComponent } from "./customer-guides-synergo/customer-guides-synergo.component";
import { NewCustomerGuideSynergoComponent } from "./customer-guides-synergo/new-customer-guide-synergo/new-customer-guide-synergo.component";

// ProfileSurvey
import { ProfileSurveisComponent } from "./profile-surveis/profile-surveis.component";
import { NewProfileSurveyComponent } from "./profile-surveis/new-profile-survey/new-profile-survey.component";
import { ProfileSurveyComponent } from "./profile-surveis/profile-survey/profile-survey.component";
import { AutocompleteProfileSurveyComponent } from "./profile-surveis/autocomplete-profile-survey/autocomplete-profile-survey.component";

// OfferArea
import { AutocompleteOfferAreaComponent } from "./offer-areas/autocomplete-offer-area/autocomplete-offer-area.component";
import { SelectOfferAreaComponent } from "./offer-areas/select-offer-area/select-offer-area.component";

// OfferPrimaryArea
import { SelectOfferPrimaryAreaComponent } from "./offer-areas/select-offer-primary-area/select-offer-primary-area.component";

// Star rating
import { StarRatingComponent } from "./star-rating/star-rating.component";

// ProfileSurveyObservation
import { ProfileSurveyObservationsComponent } from "./profile-survey-observations/profile-survey-observations.component";
import { NewProfileSurveyObservationComponent } from "./profile-survey-observations/new-profile-survey-observation/new-profile-survey-observation.component";
import { ProfileSurveyObservationComponent } from "./profile-survey-observations/profile-survey-observation/profile-survey-observation.component";
import { ProfileSurveyDimensionsComponent } from "./profile-surveis/new-profile-survey/profile-survey-dimensions/profile-survey-dimensions/profile-survey-dimensions.component";

// Station
import { StationsComponent } from "./stations/stations.component";
import { NewStationComponent } from "./stations/new-station/new-station.component";
import { StationComponent } from "./stations/station/station.component";
import { SelectStationComponent } from "./stations/select-station/select-station.component";
import { AutocompleteStationComponent } from "./stations/autocomplete-station/autocomplete-station.component";
import { MultiSelectStationsComponent } from "./stations/multiselect-stations/multiselect-stations.component";

// Manage-Claro
import { ManagementClaroComponent } from "./management-claro/management-claro.component";

//Schedule-Employees
import { ScheduleEmployeesComponent } from "./schedule-employees/schedule-employees.component";

// Shipment
import { ShipmentComponent } from "./shipments/shipment/shipment.component";
import { ShipmentsComponent } from "./shipments/shipments.component";
import { NewShipmentComponent } from "./shipments/new-shipment/new-shipment.component";

// OpeningStation
import { OpeningsStationsComponent } from "./opening-stations/openings-stations.component";
import { OpeningStationComponent } from "./opening-stations/opening-station/opening-station.component";
import { NewOpeningStationComponent } from "./opening-stations/new-opening-station/new-opening-station.component";

// Citation
import { CitationsComponent } from "./citations/citations.component";
import { CitationComponent } from "./citations/citation/citation.component";
import { NewCitationComponent } from "./citations/new-citation/new-citation.component";

// Recruitment
import { RecruitmentsComponent } from "./recruitment/recruitments.component";
import { RecruitmentComponent } from "./recruitment/recruitment/recruitment.component";
import { NewRecruitmentComponent } from "./recruitment/new-recruitment/new-recruitment.component";
import { RecruitmentsByRequisitionComponent } from "./recruitment/recruitments-by-requisition/recruitments-by-requisition.component";

// Requisition
import { RequisitionsComponent } from "./requisitions/requisitions.component";
import { RequisitionComponent } from "./requisitions/requisition/requisition.component";
import { NewRequisitionComponent } from "./requisitions/new-requisition/new-requisition.component";
import { ResumeRequisitionComponent } from "./requisitions/resume-requisition/resume-requisition.component";

// Candidate
import { CandidatesComponent } from "./candidates/candidates.component";
import { NewCandidateComponent } from "./candidates/new-candidate/new-candidate.component";
import { CandidateComponent } from "./candidates/candidate/candidate.component";
import { SelectCandidateComponent } from "./candidates/select-candidate/select-candidate.component";
import { AutocompleteCandidateComponent } from "./candidates/autocomplete-candidate/autocomplete-candidate.component";

//CandidateSynergo
import { CandidatesSynergoComponent } from "./candidates-synergo/candidates-synergo.component";
import { NewCandidateSynergoComponent } from "./candidates-synergo/new-candidate-synergo/new-candidate-synergo.component";

// CandidateComments
import { CandidateCommentsComponent } from "./candidate-comments/candidate-comments.component";
import { NewCandidateCommentComponent } from "./candidate-comments/new-candidate-comment/new-candidate-comment.component";
import { CandidateCommentComponent } from "./candidate-comments/candidate-comment/candidate-comment.component";

// Education
import { EducationsComponent } from "./educations/educations.component";
import { NewEducationComponent } from "./educations/new-education/new-education.component";
import { EducationComponent } from "./educations/education/education.component";

// WorkExperience
import { WorkExperiencesComponent } from "./work-experiences/work-experiences.component";
import { NewWorkExperienceComponent } from "./work-experiences/new-work-experience/new-work-experience.component";
import { WorkExperienceComponent } from "./work-experiences/work-experience/work-experience.component";

// Pqr
import { PqrsComponent } from "./pqrs/pqrs.component";
import { NewPqrComponent } from "./pqrs/new-pqr/new-pqr.component";
import { PqrComponent } from "./pqrs/pqr/pqr.component";

// PqrTypification
import { PqrTypificationsComponent } from "./pqr-typifications/pqr-typifications.component";
import { NewPqrTypificationComponent } from "./pqr-typifications/new-pqr-typification/new-pqr-typification.component";
import { PqrTypificationComponent } from "./pqr-typifications/pqr-typification/pqr-typification.component";
import { SelectPqrTypificationComponent } from "./pqr-typifications/select-pqr-typification/select-pqr-typification.component";

// Development requests
import { DevelopmentRequestsComponent } from "./development-requests/development-requests.component";
import { NewDevelopmentRequestsComponent } from "./development-requests/new-development-requests/new-development-requests.component";

// Systems-requests
import { SystemsRequestsComponent } from "./systems-requests/systems-requests.component";
import { NewSystemRequestComponent } from "./systems-requests/new-system-request/new-system-request.component";

// Systems Inventory Requests
import { SystemsInventoryRequestsComponent } from "./systems-inventory-requests/systems-inventory-requests.component";
import { NewSystemsInventoryRequestComponent } from "./systems-inventory-requests/new-systems-inventory-request/new-systems-inventory-request.component";

// Medical cases
import { MedicalCasesComponent } from "./medical-cases/medical-cases.component";
import { NewMedicalCaseComponent } from "./medical-cases/new-medical-case/new-medical-case.component";
import { UploadDocumentsComponent } from "./medical-cases/upload-documents/upload-documents.component";

// Bank
import { BanksComponent } from "./banks/banks.component";
import { NewBankComponent } from "./banks/new-bank/new-bank.component";
import { BankComponent } from "./banks/bank/bank.component";
import { SelectBankComponent } from "./banks/select-bank/select-bank.component";

// RadicationsSS
import { RadicationsSSComponent } from "./radication-ss/radications-ss.component";
import { NewRadicationSSComponent } from "./radication-ss/new-radication-ss/new-radication-ss.component";
import { RadicationSSComponent } from "./radication-ss/radication-ss/radication-ss.component";

// Finding
import { FindingsComponent } from "./findings/findings.component";
import { NewFindingComponent } from "./findings/new-finding/new-finding.component";
import { FindingComponent } from "./findings/finding/finding.component";

// RequisitionTask
import { RequisitionTasksComponent } from "./requisition-tasks/requisition-tasks.component";
import { NewRequisitionTaskComponent } from "./requisition-tasks/new-requisition-task/new-requisition-task.component";
import { RequisitionTaskComponent } from "./requisition-tasks/requisition-task/requisition-task.component";

// Archive
import { ArchivesComponent } from "./archives/archives.component";
import { NewArchiveComponent } from "./archives/new-archive/new-archive.component";
import { ArchiveComponent } from "./archives/archive/archive.component";

// Directory
import { DirectorysComponent } from "./directorys/directorys.component";

// Worker Care
import { WorkerCaresComponent } from "./worker-care/worker-cares.component";
import { NewWorkerCareComponent } from "./worker-care/new-worker-care/new-worker-care.component";
import { WorkerCareComponent } from "./worker-care/worker-care/worker-care.component";

// Gestión SAC
import { GestionSACsComponent } from "./gestionSACs/gestionSACs.component";
import { NewGestionSACComponent } from "./gestionSACs/new-gestionSAC/new-gestionSAC.component";
import { GestionSACComponent } from "./gestionSACs/gestionSAC/gestionSAC.component";

// BankBook
import { BankBooksComponent } from "./bank-books/bank-books.component";

// Minute
import { MinutesComponent } from "./minutes/minutes.component";
import { MinuteComponent } from "./minutes/minute/minute.component";
import { NewMinuteComponent } from "./minutes/new-minute/new-minute.component";

// DailyVisit
import { DailyVisitsComponent } from "./daily-visits/daily-visits.component";
import { DailyVisitComponent } from "./daily-visits/daily-visit/daily-visit.component";
import { NewDailyVisitComponent } from "./daily-visits/new-daily-visit/new-daily-visit.component";

// ChecklistProfileSurvey
import { ChecklistProfileSurveisComponent } from "./checklist-profile-surveis/checklist-profile-surveis.component";
import { ChecklistProfileSurveyComponent } from "./checklist-profile-surveis/checklist-profile-survey/checklist-profile-survey.component";
import { NewChecklistProfileSurveyComponent } from "./checklist-profile-surveis/new-checklist-profile-survey/new-checklist-profile-survey.component";

// FolderShare
import { FolderSharesComponent } from "./folder-shares/folder-shares.component";
import { NewFolderShareComponent } from "./folder-shares/new-folder-share/new-folder-share.component";
import { FolderShareComponent } from "./folder-shares/folder-share/folder-share.component";

// ListDocumentProfileSurvey
import { ListDocumentProfileSurveisComponent } from "./list-document-profile-surveis/list-document-profile-surveis.component";
import { ListDocumentProfileSurveyComponent } from "./list-document-profile-surveis/list-document-profile-survey/list-document-profile-survey.component";
import { NewListDocumentProfileSurveyComponent } from "./list-document-profile-surveis/new-list-document-profile-survey/new-list-document-profile-survey.component";
import { SelectListDocumentProfileSurveyComponent } from "./list-document-profile-surveis/select-list-document-profile-survey/select-list-document-profile-survey.component";

// DocumentProfileSurvey
import { DocumentProfileSurveysComponent } from "./document-profile-surveys/document-profile-surveys.component";

// Municipalities
import { AutocompleteMunicipalityComponent } from "./municipalities/autocomplete-municipality/autocomplete-municipality.component";

// Contract
import { ContractsComponent } from "./contracts/contracts.component";
import { NewContractComponent } from "./contracts/new-contract/new-contract.component";
import { ContractComponent } from "./contracts/contract/contract.component";

// Tip
import { TipsComponent } from "./tips/tips.component";
import { NewTipComponent } from "./tips/new-tip/new-tip.component";
import { TipComponent } from "./tips/tip/tip.component";
import { ShowTipComponent } from "./tips/show-tip/show-tip.component";

// InspectionEquipment
import { InspectionEquipmentsComponent } from "./inspection-equipments/inspection-equipments.component";
import { NewInspectionEquipmentComponent } from "./inspection-equipments/new-inspection-equipment/new-inspection-equipment.component";
import { InspectionEquipmentComponent } from "./inspection-equipments/inspection-equipment/inspection-equipment.component";
import { AutocompleteInspectionEquipmentComponent } from "./inspection-equipments/autocomplete-inspection-equipment/autocomplete-inspection-equipment.component";

// Inspection
import { InspectionsComponent } from "./inspections/inspections.component";
import { NewInspectionComponent } from "./inspections/new-inspection/new-inspection.component";
import { InspectionComponent } from "./inspections/inspection/inspection.component";

// Routes
import { RoutesComponent } from "./routes/routes.component";
import { NewRouteComponent } from "./routes/new-route/new-route.component";
import { RouteComponent } from "./routes/route/route.component";
import { AutocompleteRouteComponent } from "./routes/autocomplete-route/autocomplete-route.component";

// Theft
import { TheftsComponent } from "./thefts/thefts.component";
import { NewTheftComponent } from "./thefts/new-theft/new-theft.component";
import { TheftComponent } from "./thefts/theft/theft.component";

// Expired-documents
import { ExpiredDocumentsComponent } from "./expired-documents/expired-documents.component";

// Synergo
import { SynergoCitationsComponent } from "./synergo/synergo-citations/synergo-citations.component";
import { SynergoCitationComponent } from "./synergo/synergo-citations/synergo-citation/synergo-citation/synergo-citation.component";
import { SynergoNewCitationComponent } from "./synergo/synergo-citations/synergo-new-citation/synergo-new-citation.component";
import { SynergoRequisitionsComponent } from "./synergo/synergo-requisitions/synergo-requisitions.component";
import { SynergoNewRequisitionComponent } from "./synergo/synergo-requisitions/synergo-new-requisition/synergo-new-requisition.component";

import { AutocompleteProfessionComponent } from "./professions/autocomplete-profession/autocomplete-profession.component";
import { SelectHeightComponent } from "./heights/select-height/select-height.component";
import { SelectCountryComponent } from "./countries/select-country/select-country.component";
import { SelectMunicipalityComponent } from "./municipalities/select-municipality/select-municipality.component";
import { SelectAdministrativeDivisionComponent } from "./administrative-division/select-administrative-division/select-administrative-division.component";


import { LanguageModule } from "../../language/language.module";
import { ControlRequiredPipe } from "../pipe/controlRequired/controlRequired.pipe";
import { ApplicationPipesModuleModule } from "../../application-pipes-module/application-pipes-module.module";
import { ExclusionCandidateFormComponent } from "./candidate-comments/exclusion-candidate-form/exclusion-candidate-form.component";
import { MedicalCasesEventComponent } from "./medical-cases/medical-cases-event/medical-cases-event.component";
import { VacationsComponent } from "./vacations/vacations.component";
import { NewVacationComponent } from "./vacations/new-vacation/new-vacation.component";
import { NewCitationInterviewComponent } from "./citations/new-citation/new-citation-interview/new-citation-interview.component";
import { ValidMedicalExamsComponent } from "./medical-exams/valid-medical-exams/valid-medical-exams.component";
import { CustomMultiselectComponent } from './profile-surveis/custom-multiselect/custom-multiselect.component';
import { ClickOutsideDirective } from '../directives/click-outside.directive';
import { AutocompleteLaboratoryComponent } from './medical-exams/autocomplete-laboratories/autocomplete-laboratory.component';

export function createTranslateLoader(http: Http) {
  return new TranslatePoHttpLoader(http, "/assets/i18n/", ".po");
}

@NgModule({
  exports: [
    AutocompleteProfessionComponent,
    SelectOfferPrimaryAreaComponent,
    SelectVenueComponent,
    SelectHeightComponent,
    SelectCountryComponent,
    SelectAdministrativeDivisionComponent,
    SelectMunicipalityComponent,
    AutocompleteMunicipalityComponent,
    AutocompleteCompanyComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    DisabilityModule,
    LanguageModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    ButtonModule,
    SplitButtonModule,
    GrowlModule,
    MessagesModule,
    InputTextModule,
    PasswordModule,
    SlideMenuModule,
    FileUploadModule,
    DataTableModule,
    SharedModule,
    InputTextareaModule,
    DropdownModule,
    ChipsModule,
    DialogModule,
    RatingModule,
    ConfirmDialogModule,
    InputMaskModule,
    GMapModule,
    CheckboxModule,
    MultiSelectModule,
    AutoCompleteModule,
    SelectButtonModule,
    InputSwitchModule,
    ChartModule,
    ToggleButtonModule,
    AccordionModule,
    PanelModule,
    CalendarModule,
    TabViewModule,
    StepsModule,
    LightboxModule,
    TooltipModule,
    EditorModule,
    RadioButtonModule,
    FieldsetModule,
    SidebarModule,
    ScheduleModule,
    ProgressBarModule,
    Angular2PromiseButtonModule.forRoot({
      spinnerTpl: '<i class="fa fa-circle-o-notch fa-spin fa-fw btn-load"></i>',
      disableBtn: true,
      btnLoadingClass: "is-loading",
      handleCurrentBtnOnly: false,
    }),
    NgaModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [Http],
      },
    }),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyD041mK0SKDmCT9s6gaZ3XAq-psuHgA_Ec",
      libraries: ["places"],
    }),
    StoreModule.forRoot({}),
    InfiniteScrollModule,
    NgxChartsModule,
    Angular2FontawesomeModule,
    DndModule,
    ApplicationPipesModuleModule,
  ],
  declarations: [
    PagesComponent,
    DashboardComponent,
    DashboardFinancialComponent,
    DashboardSorttimeCompaniesComponent,
    // LoginComponent,
    // LoginCandidateComponent,
    // SelectLanguageComponent,
    AccountComponent,
    AccountEditComponentComponent,
    EmployeeEditComponentComponent,
    UsersComponent,
    NewUserComponent,
    UserComponent,
    CompaniesComponent,
    NewCompanyComponent,
    CompanyComponent,
    SelectCompanyComponent,
    MultiSelectCompaniesComponent,
    AutocompleteCompanyComponent,
    VenuesComponent,
    NewVenueComponent,
    VenueComponent,
    SelectVenueComponent,
    DepartmentsComponent,
    NewDepartmentComponent,
    DepartmentComponent,
    SelectDepartmentComponent,
    EmployeePositionsComponent,
    NewEmployeePositionComponent,
    EmployeePositionComponent,
    SelectEmployeePositionComponent,
    AutocompleteEmployeeComponent,
    EmployeesComponent,
    NewEmployeeComponent,
    EmployeeComponent,
    SelectEmployeeComponent,
    RolesComponent,
    NewRoleComponent,
    RoleComponent,
    SelectRoleComponent,
    PermissionsComponent,
    NewPermissionComponent,
    PermissionComponent,
    MultiSelectPermissionComponent,
    CustomerGuidesComponent,
    NewCustomerGuideComponent,
    CustomerGuidesSynergoComponent,
    NewCustomerGuideSynergoComponent,
    CustomerGuideComponent,
    AutocompleteCustomerGuideComponent,
    CustomerGuidesAttachDocumentationComponent,
    ProfileSurveisComponent,
    NewProfileSurveyComponent,
    ProfileSurveyComponent,
    AutocompleteProfileSurveyComponent,
    ProfileSurveyObservationsComponent,
    NewProfileSurveyObservationComponent,
    ProfileSurveyObservationComponent,
    StationsComponent,
    NewStationComponent,
    StationComponent,
    SelectStationComponent,
    AutocompleteStationComponent,
    MultiSelectStationsComponent,
    ManagementClaroComponent,
    ScheduleEmployeesComponent,
    ShipmentComponent,
    ShipmentsComponent,
    NewShipmentComponent,
    OpeningsStationsComponent,
    NewOpeningStationComponent,
    OpeningStationComponent,
    CitationsComponent,
    NewCitationComponent,
    CitationComponent,
    RecruitmentsComponent,
    RecruitmentComponent,
    NewRecruitmentComponent,
    RecruitmentsByRequisitionComponent,
    RequisitionsComponent,
    NewRequisitionComponent,
    ResumeRequisitionComponent,
    RequisitionComponent,
    CandidatesComponent,
    NewCandidateComponent,
    CandidateComponent,
    SelectCandidateComponent,
    AutocompleteCandidateComponent,
    CandidateCommentsComponent,
    NewCandidateCommentComponent,
    CandidateCommentComponent,
    EducationsComponent,
    NewEducationComponent,
    EducationComponent,
    WorkExperiencesComponent,
    NewWorkExperienceComponent,
    WorkExperienceComponent,
    PqrsComponent,
    NewPqrComponent,
    PqrComponent,
    PqrTypificationsComponent,
    NewPqrTypificationComponent,
    PqrTypificationComponent,
    SelectPqrTypificationComponent,
    DevelopmentRequestsComponent,
    NewDevelopmentRequestsComponent,
    MedicalCasesComponent,
    NewMedicalCaseComponent,
    MedicalCasesEventComponent,
    UploadDocumentsComponent,
    SystemsInventoryRequestsComponent,
    NewSystemsInventoryRequestComponent,
    SystemsRequestsComponent,
    NewSystemRequestComponent,
    BanksComponent,
    NewBankComponent,
    BankComponent,
    SelectBankComponent,
    BankBooksComponent,
    RadicationsSSComponent,
    NewRadicationSSComponent,
    RadicationSSComponent,
    FindingsComponent,
    NewFindingComponent,
    FindingComponent,
    RequisitionTasksComponent,
    NewRequisitionTaskComponent,
    RequisitionTaskComponent,
    ArchivesComponent,
    NewArchiveComponent,
    ArchiveComponent,
    DirectorysComponent,
    WorkerCaresComponent,
    NewWorkerCareComponent,
    WorkerCareComponent,
    GestionSACsComponent,
    NewGestionSACComponent,
    GestionSACComponent,
    MinutesComponent,
    NewMinuteComponent,
    MinuteComponent,
    DailyVisitsComponent,
    DailyVisitComponent,
    NewDailyVisitComponent,
    ChecklistProfileSurveisComponent,
    ChecklistProfileSurveyComponent,
    NewChecklistProfileSurveyComponent,
    FolderSharesComponent,
    NewFolderShareComponent,
    FolderShareComponent,
    ListDocumentProfileSurveisComponent,
    ListDocumentProfileSurveyComponent,
    NewListDocumentProfileSurveyComponent,
    SelectListDocumentProfileSurveyComponent,
    SelectCountryComponent,
    SelectAdministrativeDivisionComponent,
    SelectMunicipalityComponent,
    AutocompleteMunicipalityComponent,
    SelectHeightComponent,
    ContractsComponent,
    NewContractComponent,
    ContractComponent,
    TipsComponent,
    NewTipComponent,
    TipComponent,
    ShowTipComponent,
    InspectionEquipmentsComponent,
    NewInspectionEquipmentComponent,
    InspectionEquipmentComponent,
    InspectionsComponent,
    NewInspectionComponent,
    InspectionComponent,
    RoutesComponent,
    NewRouteComponent,
    RouteComponent,
    AutocompleteRouteComponent,
    TheftsComponent,
    NewTheftComponent,
    TheftComponent,
    ExpiredDocumentsComponent,
    AutocompleteInspectionEquipmentComponent,
    DocumentProfileSurveysComponent,
    SynergoCitationsComponent,
    SynergoCitationComponent,
    SynergoNewCitationComponent,
    SynergoRequisitionsComponent,
    SynergoNewRequisitionComponent,
    ProfileSurveyDimensionsComponent,
    AutocompleteProfessionComponent,
    AutocompleteOfferAreaComponent,
    SelectOfferAreaComponent,
    SelectOfferPrimaryAreaComponent,
    StarRatingComponent,
    EmployeeVirtualOfficeComponent,
    ControlRequiredPipe,
    ExclusionCandidateFormComponent,
    VacationsComponent,
    NewVacationComponent,
    NewCitationInterviewComponent,
    CandidatesSynergoComponent,
    NewCandidateSynergoComponent,
    ValidMedicalExamsComponent,
    CustomMultiselectComponent,
    ClickOutsideDirective,
    AutocompleteLaboratoryComponent
  ]
})
export class PagesModule { }



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pages.module.ts